import { Price } from "@/types/checkout/checkout";

export async function getPricesForEvent(eventUuid: string): Promise<Price[]> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/prices/event/${eventUuid}`, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error('Failed to fetch prices for event');
    }
    return response.json();
}